module.exports = __webpack_public_path__ + "img/象棋.75850e90.jpg";